import React, { useEffect } from "react";
// import { AdminModalStateContext } from "../../context/AdminDashboard/AdminModalContext";
import BtnModal from "../atoms/BtnModal";
import Icon from "../atoms/Icon";
import InputGroup from "../atoms/InputGroup";
import Modal from "../atoms/Modal";
import SelectModal from "../atoms/SelectModal";
import TextArea from "../atoms/TextArea";

const Modaleditdetail = ({
  showModal,
  closeModal,
  SerialNumber,

  onchangeTextArea,
  onchangeInput,
  onchangeSerialNumber,
  onchangeAccess,
  Addcall,
  nametitle,
  title,
  searchserialNumber,
  optionLoding,
  SerialOption,
  onchangeTypeService,
  AddDone,
  doneEdit,
  name,
  textdetail,
  phoneNumber,
  service,
  nameOwner,
  numberOwner,
  btnClick,
  
}) => {
  let serviceoption = [
    { value: "تعویض دستگاه", label: "تعویض دستگاه" },
    { value: "تعویض قطعه", label: "تعویض قطعه" },
    { value: "خدمات نرم افزاری", label: "خدمات نرم افزاری" },
  ];

  //   let nameReadOnly = Addcall?false:true;
  //   let onchange = Addcall?onchangeInput:false;
  //   let numberval = Addcall ? null :modalData.nameOwner;
  // console.log(modalData.nameOwner)
  // let btnClick = Addcall ? AddDone : doneEdit;
  let btntext = Addcall ? "تایید اطلاعات و افزودن" : "تایید اطلاعات و ویرایش";

  let textitle = Addcall ? `ثبت ورودی جدید ` : `ویرایش ورودی  “${title}”`;

  return (
    <div dir="rtl">
      {showModal ? (
        <>
          <Modal title={textitle} closeModal={closeModal}>
            <div className="flex flex-row w-594 gap-3.6 mb-5">
              <InputGroup
                placeholder=""
                label={"شماره سریال"}
                value={  SerialNumber }
                iconName="cpuB"
                able={false}
                id="serialnumber"
              />
              <SelectModal
                label={"نوع خدمات"}
                iconName="setting-3"
                defaultO={service}
                values={serviceoption}
                onchange={onchangeTypeService}
                able={Addcall}
                placeholder={"یک گزینه را انتخاب کنید"}
                wbox="227.5px"
              />
            </div>
            <div className="flex flex-row w-594 gap-3.6 mb-5">
              <InputGroup
                placeholder="مانند علی میرهادی"
                label={"نام و نام خانوادگی مالک (غیر قابل ویرایش)"}
                value={nameOwner}
                iconName="userF"
                able={false}
                id="name"
              />
              <InputGroup
                placeholder="مانند 09215863622"
                label={"شماره تماس مالک (غیر قابل ویرایش)"}
                value={numberOwner.replace("+98", "0")}
                iconName="call"
                able={false}
                id="number"
              />
            </div>
            <div className="flex flex-row w-594 gap-3.6 mb-5">
              <TextArea
                iconName={"note-2"}
                label="توضیحات (اختیاری)"
                text={textdetail}
                width="mt-0"
                onchange={onchangeTextArea}
              />
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end pt-5.5">
              <BtnModal text={btntext} accept={btnClick} />
            </div>
          </Modal>
        </>
      ) : null}
    </div>
  );
};
export default Modaleditdetail;
